import TYPES from './types';

const INITIAL_STATE = {
  whitelistedOrganizations: []
};

const reducer = (state = INITIAL_STATE, { type, payload }) => {
  switch (type) {
    case TYPES.GET_WIDGET_VISIBILITY.SUCCESS:
      return {
        ...state,
        whitelistedOrganizations: payload.organization_ids
      };
    default:
      return state;
  }
};

export default reducer;
